import React, { useEffect, useState } from "react";
import axios from "axios";
import { Anchor, Badge, Box, Container, Group, Paper, Stack, Text, Title } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useParams } from "react-router-dom";
import config from "../../config";
import MarkdownPreview from "../../components/Knowledge/MarkdownPreview";
import KnowledgeProtectedContent from "../../components/Knowledge/KnowledgeProtectedContent";
import { formatDate, ml } from "../../components/Knowledge/knowledgeUtils";

export default function PublicKnowledgeArticle() {
	const { idOrSlug } = useParams();
	const [article, setArticle] = useState(null);
	const [notFound, setNotFound] = useState(false);

	useEffect(() => {
		let mounted = true;
		const url = `${config.api.API_URL}/${config.api.API_Version}/public/knowledge/articles/${encodeURIComponent(idOrSlug)}`;
		axios.get(url)
			.then((response) => {
				if (mounted) setArticle(response.data);
			})
			.catch(() => {
				if (mounted) setNotFound(true);
				notifications.show({ color: "red", title: "Article unavailable", message: "This public article could not be opened." });
			});
		return () => {
			mounted = false;
		};
	}, [idOrSlug]);

	if (notFound) {
		return (
			<Box mih="100vh" py={80}>
				<Container size="md">
					<Title order={2}>Article unavailable</Title>
					<Text color="dimmed" mt="sm">This public link is not available.</Text>
				</Container>
			</Box>
		);
	}

	if (!article) {
		return (
			<Box mih="100vh" py={80}>
				<Container size="md">
					<Text color="dimmed">Loading article...</Text>
				</Container>
			</Box>
		);
	}

	return (
		<Box mih="100vh" py={{ base: 32, sm: 56 }}>
			<Container size="md">
				<Paper withBorder radius="sm" p={{ base: "md", sm: "xl" }}>
					<KnowledgeProtectedContent>
					<Stack spacing="md">
						<Group position="apart" align="flex-start">
							<Stack spacing={6}>
								<Group spacing="xs">
									<Badge color="teal">public</Badge>
									{article.status ? <Badge color="green">{article.status}</Badge> : null}
								</Group>
								<Title order={1}>{ml(article.title) || article.slug}</Title>
								<Text color="dimmed" size="sm">
									Published {formatDate(article.publishedAt || article.updatedAt)}
								</Text>
							</Stack>
						</Group>
						{ml(article.summary) ? <Text color="dimmed">{ml(article.summary)}</Text> : null}
						{(article.tags || []).length ? (
							<Group spacing="xs">
								{article.tags.map((tag) => <Badge key={tag} variant="light">{tag}</Badge>)}
							</Group>
						) : null}
						<MarkdownPreview markdown={ml(article.contentMarkdown)} />
						<Text size="xs" color="dimmed">
							Shared from <Anchor href="/" color="dimmed">APIT Knowledge Base</Anchor>
						</Text>
					</Stack>
					</KnowledgeProtectedContent>
				</Paper>
			</Container>
		</Box>
	);
}
